import { fromJS } from 'immutable';
import { useMemo, useState } from 'react';
import { ReportingILSStrategyBuilder } from 'customer-data-filters-ui/public/strategies';
import { hasObjectTypeId } from '../../../utils/source-utils';
import { toDSFieldRecord, canUseReferenceResolverLite
// @ts-expect-error untyped import
} from '../xo-filter-utils';
// @ts-expect-error untyped import
import { getReferenceType } from '../../../metadata/references/external/external-mapping';
import PropertyRecord from 'customer-data-objects/property/PropertyRecord';
import { logMessage } from 'reporting-data/monitoring/logger';
import { useFilterRelevantUserInfo } from '../../../../shared/lib/utils';
import { MIGRATE_LEGACY_ILS_DATE_TIME_FILTERS } from 'reporting-data/constants/gates';
import { SEQUENCE_STEP_ORDER, SALESFORCE_CAMPAIGN, DEAL_PIPELINE, DEAL_PIPELINE_STAGE, BLOG_TAG, BLOG_AUTHOR, TICKET_PIPELINE, TICKET_STAGE, TICKET, EMAIL
//@ts-expect-error untyped import
} from 'reference-resolvers/constants/ReferenceObjectTypes';
//@ts-expect-error untyped import
import { useTableDescription } from '../components/SourceMeta';
import { getTableDescriptionMetaWithCache } from '../../../metadata/table-description-meta';
//temporary - this prevents disrupting old filters, but once the migration is complete, we can remove this
const UNSUPPORTED_REFERENCE_TYPES = [SEQUENCE_STEP_ORDER, SALESFORCE_CAMPAIGN, DEAL_PIPELINE, DEAL_PIPELINE_STAGE, BLOG_TAG, BLOG_AUTHOR, TICKET_STAGE, TICKET_PIPELINE, TICKET, EMAIL];
export const useSnowflakeObjectStrategy = ({
  source,
  reportingFilterContext = 'snowflake_object',
  filterFamilyOverride,
  isRelativeTimeProperty
}) => {
  const [result, setResult] = useState(null);
  const dataType = hasObjectTypeId(source) ? source.objectTypeId : source.dataSourceId;
  const tableDescription = useTableDescription();
  const tableDescriptionMeta = getTableDescriptionMetaWithCache(tableDescription);
  tableDescriptionMeta.then(({
    properties: snowflakeProperties
  }) => {
    const propertyName = source.type === 'EXTERNAL_DATASOURCE' ? source.label.replaceAll('-', '_').replaceAll('.', '_') : source.name;
    setResult(snowflakeProperties.get(propertyName));
  }).catch(error => {
    console.error(error);
  });
  const {
    userGates
  } = useFilterRelevantUserInfo();
  const strategy = useMemo(() => {
    // Convert to correct DSFieldRecordType
    if (!result || !userGates || !userGates.length) {
      return null;
    }
    const updatedProps = result.map(prop => {
      const referenceType = getReferenceType(source, prop);
      const externalOptionsReferenceType = prop.externalOptionsReferenceType;
      let newProp = prop;
      if (referenceType && referenceType !== externalOptionsReferenceType && !UNSUPPORTED_REFERENCE_TYPES.includes(referenceType)) {
        newProp = prop.withMutations(currentValue => currentValue.set('externalOptions', true).set('externalOptionsReferenceType', referenceType));
        logMessage({
          message: 'FE referenceType mismatch',
          extra: {
            FEReference: referenceType,
            BEReference: externalOptionsReferenceType,
            dataType,
            prop: prop.toJS()
          }
        });
      }
      let fieldRecord = toDSFieldRecord(PropertyRecord(fromJS(newProp)), source);
      if (referenceType && 'referencedObjectType' in fieldRecord && !canUseReferenceResolverLite(source, prop, userGates)) {
        fieldRecord = fieldRecord.set('referencedObjectType', referenceType);
        logMessage({
          message: 'FE set referencedObjectType for non-RRL property',
          extra: {
            FEReference: referenceType,
            BEReference: externalOptionsReferenceType,
            dataType,
            prop: prop.toJS()
          }
        });
      }
      return fieldRecord;
    });
    return ReportingILSStrategyBuilder({
      getField: (_, id, originalField) => {
        return updatedProps.get(id) || originalField;
      },
      getFields: () => updatedProps,
      getFilterFamilyName: () => filterFamilyOverride || dataType,
      getFilterFamilyObjectName: () => filterFamilyOverride || dataType,
      reportingFilterContext,
      supportsLegacyILSDateTimeFilters: !userGates.includes(MIGRATE_LEGACY_ILS_DATE_TIME_FILTERS),
      isIncludeObjectsWithNoValueSetCheckboxEnabled: true,
      isRelativeTimeProperty: isRelativeTimeProperty || false
    });
  }, [result, dataType, source, reportingFilterContext, userGates, filterFamilyOverride, isRelativeTimeProperty]);
  return strategy;
};